import React from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { COLORS } from 'config/constants';

import LockedIconBadge from '../locked-icon-badge';

import './locked-icon-button.scss';

const LockedIconButton = ({ children, className, ...rest }: CommonLockedIconButtonProps) => {
  const { t } = useTranslation();

  return (
    <Tooltip placement='right' title={<Typography variant='body2'>
      {t('calc__text__submittedForPreparation')}
    </Typography>}>
      <span className='locked-icon-button-hint' tabIndex={0}>
        <IconButton
          aria-label={t('calc__text__lockedByApplication')}
          className={cx('locked-icon-button', className)}
          disabled
          {...rest}
          sx={{
            ...rest.sx,
            '&:disabled': {
              opacity: 1,
              color: COLORS.LIGHT_TEXT_DISABLED,
            },
          }}
        >
          <LockedIconBadge>
            {children}
          </LockedIconBadge>
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default LockedIconButton;
